import { LoanType } from './LoanType';
import { LoanSubType } from './LoanSubType';

export const LoanSubTypeOptions = [
    {
        id: LoanSubType.InventoryLoan,
        name: 'Inventory Loan',
        shortName: 'Inv. Loan',
        sortOrder: 1,
        active: true,
        loanType: LoanType.Bridge,
    },
    {
        id: LoanSubType.AcquisitionBridge,
        name: 'Acquisition Bridge',
        shortName: 'Acq. Brdg',
        sortOrder: 2,
        active: true,
        loanType: LoanType.Bridge,
    },
];
